import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import {
  IPrizesParams,
  IPrizesResponse,
  Profile,
  ServiceCallResponse,
  Winner,
} from '@fantaz/shared/data-access/models';
import { catchError, map, Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WinnerApiService {
  constructor(private http: HttpClient) {}

  fetchWinner(data: {
    eventInstanceId: string;
    playInstanceId: string;
  }): Observable<ServiceCallResponse<Winner>> {
    return this.http
      .get<Winner>(
        `${environment.apiBaseUrl}/core-client/api/user/confirm/shipping?ei=${data.eventInstanceId}&pi=${data.playInstanceId}`,
      )
      .pipe(
        map((response) => {
          return { success: true, payload: response };
        }),
        catchError((err) => {
          if (err.status === 400) {
            return of({
              success: false,
              error: {
                message: 'The confirmation link is not valid',
                code: 400,
                err,
              },
            });
          }

          if (err.status === 403) {
            return of({
              success: false,
              error: {
                message: 'You are not authorized to view the winner result.',
                code: 401,
                err,
              },
            });
          }
          return throwError(() => {
            return err;
          });
        }),
      );
  }

  confirmAddress(data: {
    eventInstanceId: string;
    playInstanceId: string;
    profile: Profile;
  }): Observable<ServiceCallResponse<void>> {
    return this.http
      .post<{ message: string }>(
        `${environment.apiBaseUrl}/core-client/api/user/confirm/shipping?ei=${data.eventInstanceId}&pi=${data.playInstanceId}`,
        {
          firstName: data.profile.firstName,
          lastName: data.profile.lastName,
          phone: data.profile.phone,
          shippingAddress: {
            ...data.profile.shippingAddress,
            country: 'US', // for now always send US
          },
        },
      )
      .pipe(
        map((response) => {
          if (response.message === 'done') {
            return { success: true };
          }
          return { success: false };
        }),
        catchError((err) => {
          console.log('Error from confirm response', err);
          if (err.status === 403) {
            return of({
              success: false,
              error: {
                message: 'You are not authorized to confirm the winner result',
                code: 403,
                err,
              },
            });
          }
          return throwError(() => {
            return err;
          });
        }),
      );
  }

  getPrizesWon(params: IPrizesParams): Observable<IPrizesResponse> {
    return this.http.post<IPrizesResponse>(
      `${environment.apiBaseUrl}/core-client/api/user/prizes`,
      params,
    );
  }
}
